export default {
  CREDITO_CODE: 1,
  CONTRA_ENTREGA_CODE: 2,
  CONTADO_CODE: 3
}
